(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["esp-occasion-grid"] && !Shopify.designMode) return;
  try {
    
  const setupEspOccasionRail = (section) => {
    if (!section || section.dataset.espOccasionReady === 'true') return;

    const rail = section.querySelector('[data-esp-occasion-rail]');
    const previous = section.querySelector('[data-esp-occasion-previous]');
    const next = section.querySelector('[data-esp-occasion-next]');
    if (!rail || !previous || !next) return;

    section.dataset.espOccasionReady = 'true';

    const cardStep = () => {
      const card = rail.querySelector('.esp-occasion-card');
      if (!card) return rail.clientWidth;
      const styles = getComputedStyle(rail);
      const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
      return card.getBoundingClientRect().width + gap;
    };

    const updateBoundaries = () => {
      const maxScroll = Math.max(0, rail.scrollWidth - rail.clientWidth);
      previous.disabled = rail.scrollLeft <= 1;
      next.disabled = rail.scrollLeft >= maxScroll - 1;
    };

    const move = (direction) => {
      rail.scrollBy({ left: cardStep() * direction, behavior: 'smooth' });
    };

    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    rail.addEventListener('scroll', updateBoundaries, { passive: true });
    rail.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      move(event.key === 'ArrowLeft' ? -1 : 1);
    });

    new ResizeObserver(updateBoundaries).observe(rail);
    requestAnimationFrame(updateBoundaries);
  };

  document.querySelectorAll('[data-esp-occasion]').forEach(setupEspOccasionRail);
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.matches('[data-esp-occasion]')
      ? event.target
      : event.target.querySelector('[data-esp-occasion]');
    setupEspOccasionRail(section);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
